import React, { useEffect, useState, useCallback, useRef } from 'react';
import * as Sentry from '@sentry/react';
import { safeLocalStorage } from '../utils/storage';
import './LoadingScreen.css';

const LoadingScreen: React.FC = () => {
  const [countdown, setCountdown] = useState(5);
  const hasRedirectedRef = useRef(false);

  const handleRedirect = useCallback(() => {
    if (hasRedirectedRef.current) {
      return;
    }
    hasRedirectedRef.current = true;
    const url = safeLocalStorage.getItem('auth_return_url');
    Sentry.captureMessage('LoadingScreen component reached - unexpected auth state', {
      level: 'warning',
      tags: {
        component: 'LoadingScreen',
        issue: 'unexpected_auth_redirect_state'
      },
      extra: {
        auth_return_url: url,
        user_agent: navigator.userAgent,
        timestamp: new Date().toISOString()
      }
    });
    if (url) {
      safeLocalStorage.removeItem('auth_return_url');
      window.location.href = url;
    } else {
      window.location.href = '/';
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          handleRedirect();          
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [handleRedirect]);

  return (
    <div className="loading-screen">
      <header className="app-header loading-header">
        <div className="header-container">
          <div className="header-left">
            <div className="skeleton skeleton-logo"></div>
          </div>
          <div className="header-right">
            <div className="skeleton skeleton-nav-item"></div>
            <div className="skeleton skeleton-nav-item"></div>
            <div className="skeleton skeleton-avatar"></div>
          </div>
        </div>
      </header>

      <div className="loading-content">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Redirecting to your experience...</p>
          <p className="loading-countdown">Redirecting automatically in {countdown} seconds</p>
          <button 
            className="btn btn--primary"
            onClick={handleRedirect}
          >
            Continue Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;

